module.exports = __webpack_public_path__ + "files/SPIADI2025.b7b36134b6d23b7b3469e8f3c3efe290.pdf";